import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, Redirect, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function AllKingdom() {
    const [cookies] = useCookies(['user']);
    const user_id = cookies.user_id;
    const token = cookies.token;
    // const { state } = props.location
    // const [allData] = useState(state[0]);
    let history = useHistory();
    const [error1, setError] = useState(false);
    const [kds, setKds] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const handleNavCollapse = () => { setIsNavCollapsed(!isNavCollapsed) };
    const [warUpdate, setWarUpdate] = useState('');
    const warRow = [];
    const row = [];
    useEffect(() => {
        getUserData();
        getAllLiveWar();
    }, []);

    const getUserData = async () => {
        // console.log(allData);
        localStorage.setItem("chat_users", '');
        localStorage.setItem("cg_id", '');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ user_id: user_id }),

        };
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-all-kingdom-and-chat-group', requestOptions);

        const data = await response.json();
        console.log(data);
        //sort by war_status
        data.wars.sort((a, b) => a['war_status'] - b['war_status']);
        if (data.status === "success") {
            for (const [index, value] of data.wars.entries()) {
                console.log(value);
                let image = JSON.parse(value.image);
                let img = image.image;
                console.log(img);
                if (value.war_status == 1) {
                    let kd1per = { width: (value.kd1_points * 100 / (value.kd1_points + value.kd2_points)).toFixed(0) + "%" };
                    let kd2per = { width: (100 - (value.kd1_points * 100 / (value.kd1_points + value.kd2_points)).toFixed(0)) + "%" };
                    if (value.kd1_points == 0 && value.kd2_points == 0) {
                        kd1per = { width: "50%" };
                        kd2per = { width: "50%" };
                    }
                    var card = <div className="row section mb-3" key={index}>
                        <div className='profile-war-info w-100 px-3' style={{
                            backgroundImage: `url(${img})`,
                            backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)) , url(${img})`,
                            backgroundSize: `100% 100%`
                        }}>
                            <div className="row paddingTop">
                                <span className="profile-kd-name">{value.name}</span>
                            </div>
                            <div className="row paddingTop section">
                                <div className="region-war-ranks w-100">
                                    <Link to={{
                                        pathname: "/war-history",
                                        state: [value]
                                    }} className="reg-match-won w-50">
                                        <div>Matches Won <span className="hglt-class">{value.war_won}</span>
                                        </div>
                                    </Link>
                                    <Link to={{
                                        pathname: "/kingdom-leaderboard",
                                        state: [{ 'k_id': '' }]
                                    }} className="reg-regn-rang w-50">
                                        <div>Region Rank <span className="hglt-class">{value.rank}</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            {/*
                            <div className="row paddingTop">
                                <Link to={{
                                    pathname:"/war-history",
                                    state: [value]
                                }} className="profile-ww w-100">
                                    <div className="profile-ww-l profile-flt-l w-70">Wars Won</div>
                                    <div className="profile-ww-r profile-flt-l w-30">
                                        <span className="profile-ww-won">{value.war_won}/</span>
                                        <span className="profile-ww-total">{value.total_war}</span>
                                    </div>
                                </Link>
                            </div>
                            */}
                            <div className="row section paddingTop paddingBottom">
                                <div className="profile-war-info-inside w-100">
                                    <div className="w-100 battle-info profile-flt-l">
                                        <div className="w-75 profile-flt-l">
                                            <div className="w-100 profile-flt-l prof-war-head-left fnt-wt-500">{value.kd1_name} v/s {value.kd2_name}</div>
                                        </div>
                                        <div className="w-25 profile-flt-l">
                                            <Link to={{
                                                pathname: "/war-score",
                                                state: [value, value.war_id]
                                            }} className="w-100 profile-flt-l prof-war-head-right color-white fnt-wt-400 fnt-10">
                                                Battle Details
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="w-100 bat-cls profile-flt-l fnt-12 fnt-wt-400">Battle No. {value.battle_no}</div>
                                    <div className="profile-war-data-score-2 w-100 profile-flt-l">
                                        <div className="score-range w-100">
                                            <div className="score-range-left profile-flt-l" style={kd1per}>&nbsp;</div>
                                            <div className="score-range-right profile-flt-l" style={kd2per}>&nbsp;</div>
                                        </div>
                                    </div>
                                    <div className="profile-war-data-bottom w-100 profile-flt-l">
                                        <div className="w-50 profile-flt-l text-alg-left">
                                            <div className="w-100 profile-flt-l team-score">{value.kd1_points.toLocaleString('en-In', { maximumFractionDigits: 0 })}</div>
                                            <div className="w-100 profile-flt-l score-team">{value.kd1_name}</div>
                                        </div>
                                        <div className="w-50 profile-flt-l text-alg-right">
                                            <div className="w-100 profile-flt-l team-score">{value.kd2_points.toLocaleString('en-In', { maximumFractionDigits: 0 })}</div>
                                            <div className="w-100 profile-flt-l score-team">{value.kd2_name}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="row section paddingTop paddingBottom">
                                <div className="profile-war-info-inside w-100">
                                    <div className="profile-war-header w-100 profile-flt-l">
                                        <div className="w-100 profile-flt-l prof-war-head-left">{value.kd1_name} v/s {value.kd2_name}</div>
                                    </div>
                                    <div className="profile-war-data-score w-100 profile-flt-l">
                                        <div className="score-range w-100">
                                            <div className="score-range-left profile-flt-l" style={kd1per}>&nbsp;</div>
                                            <div className="score-range-right profile-flt-l" style={kd2per}>&nbsp;</div>
                                        </div>
                                    </div>
                                    <div className="profile-war-data-bottom w-100 profile-flt-l">
                                        <div className="w-50 profile-flt-l text-alg-left">
                                            <div className="w-100 profile-flt-l score-team">{value.kd1_name}</div>
                                            <div className="w-100 profile-flt-l team-score">{value.kd1_points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                                        </div>
                                        <div className="w-50 profile-flt-l text-alg-right">
                                            <div className="w-100 profile-flt-l score-team">{value.kd2_name}</div>
                                            <div className="w-100 profile-flt-l team-score">{value.kd2_points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                                        </div>
                                    </div>
                                    <div className="profile-war-footer w-100 profile-flt-l">
                                        <div className="w-50 profile-flt-l prof-war-head-left">&nbsp;</div>
                                        <Link to={{
                                            pathname:"/war-score",
                                            state: [value, value.war_id]
                                        }} className="w-50 profile-flt-l prof-war-head-right war-footer-right color-white">
                                            View War Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>;
                    row.push(card);
                } else if (value.war_status == 2) {
                    var card = <div className="row section mb-3" key={index}>
                        <div className='profile-war-info w-100 px-3' style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)) ,url(${img})`, backgroundSize: `100% 100%` }}>
                            <div className="row paddingTop">
                                <span className="profile-kd-name">{value.name}</span>
                            </div>
                            <div className="row paddingTop section">
                                <div className="region-war-ranks w-100">
                                    <Link to={{
                                        pathname: "/war-history",
                                        state: [value]
                                    }} className="reg-match-won w-50">
                                        <div>Matches Won <span className="hglt-class">{value.war_won}</span>
                                        </div>
                                    </Link>
                                    <Link to={{
                                        pathname: "/kingdom-leaderboard",
                                        state: [{ 'k_id': '' }]
                                    }} className="reg-regn-rang w-50">
                                        <div>Region Rank <span className="hglt-class">{value.rank}</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            {/*
                            <div className="row paddingTop">
                                <Link to={{
                                    pathname:"/war-history",
                                    state: [value]
                                }} className="profile-ww w-100">
                                    <div className="profile-ww-l profile-flt-l w-70">Wars Won</div>
                                    <div className="profile-ww-r profile-flt-l w-30">
                                        <span className="profile-ww-won">{value.war_won}/</span>
                                        <span className="profile-ww-total">{value.total_war}</span>
                                    </div>
                                </Link>
                            </div>
                            */}
                            <div className="row section paddingTop paddingBottom">
                                <div className="profile-war-info-inside w-100">
                                    <div className="profile-war-header w-100 profile-flt-l">
                                        <div className="w-100 profile-flt-l prof-war-head-left fnt-wt-500">{value.kd1_name} v/s {value.kd2_name}</div>
                                        <div className="region-war-schedule">
                                            <div className="rws-lft">Battle No. {value.battle_no}</div>
                                            <div className="rws-rht">{value.next_war_day + " "}<span className="rws-mnth">{value.next_war_month}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="row section paddingTop paddingBottom">
                                <div className="profile-war-info-inside w-100">
                                    <div className="profile-flt-l w-70">
                                        <div className="profile-war-header w-100 profile-flt-l">
                                            <div className="w-100 profile-flt-l prof-war-head-left">{value.kd1_name} v/s {value.kd2_name}</div>
                                        </div>
                                        <div className="profile-war-footer w-100 profile-flt-l">
                                        <div className="w-50 profile-flt-l prof-war-head-left">
                                        &nbsp;
                                        </div>
                                    </div>
                                    </div>
                                    <div className="profile-flt-l w-30 prof-war-schedule">
                                        <div className="w-100 profile-flt-l prof-war-schedule-cont">
                                            <div className="w-25 profile-flt-l">&nbsp;</div>
                                            <div className="w-50 profile-flt-l prof-war-schedule-box">
                                                <div className="w-100 sched-date">{value.next_war_day}</div>
                                                <div className="w-100 sched-month">{value.next_war_month}</div>
                                            </div>
                                            <div className="w-25 profile-flt-l">&nbsp;</div>
                                        </div>
                                        <div className="w-100 profile-flt-l prof-war-schedule-label">Date Of War</div>
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>;
                    row.push(card);
                } else if (value.war_status == 3) {
                    var card = <div className="row section mb-3" key={index}>
                        <div className='profile-war-info w-100 px-3' style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)),url(${img})`, backgroundSize: `100% 100%` }}>
                            <div className="row paddingTop">
                                <span className="profile-kd-name">{value.name}</span>
                            </div>
                            <div className="row paddingTop section">
                                <div className="region-war-ranks w-100">
                                    <Link to={{
                                        pathname: "/war-history",
                                        state: [value]
                                    }} className="reg-match-won w-50">
                                        <div>Matches Won <span className="hglt-class">{value.war_won}</span>
                                        </div>
                                    </Link>
                                    <Link to={{
                                        pathname: "/kingdom-leaderboard",
                                        state: [{ 'k_id': '' }]
                                    }} className="reg-regn-rang w-50">
                                        <div>Region Rank <span className="hglt-class">{value.rank}</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            {/*
                            <div className="row paddingTop">
                                <Link to={{
                                    pathname:"/war-history",
                                    state: [value]
                                }} className="profile-ww w-100">
                                    <div className="profile-ww-l profile-flt-l w-70">Wars Won</div>
                                    <div className="profile-ww-r profile-flt-l w-30">
                                        <span className="profile-ww-won">{value.war_won}/</span>
                                        <span className="profile-ww-total">{value.total_war}</span>
                                    </div>
                                </Link>
                            </div>
                            */}
                            <div className="row section paddingTop paddingBottom">
                                <Link
                                    to={{
                                        pathname: "/war-score",
                                        state: [value, value.war_id],
                                    }}
                                    className="profile-war-info-inside w-100"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="profile-war-info-inside w-100">
                                        <div className="w-100 battle-info profile-flt-l">
                                            <div className="w-75 profile-flt-l">
                                                <div className="w-100 profile-flt-l prof-war-head-left fnt-wt-500">{value.kd1_name} v/s {value.kd2_name}</div>
                                            </div>
                                            <div className="w-25 profile-flt-l">
                                                {/* <Link to={{
                                                    pathname: "/war-score",
                                                    state: [value, value.war_id]
                                                }} className="w-100 profile-flt-l prof-war-head-right color-white fnt-wt-400 fnt-10">
                                                    Battle Details
                                                </Link> */}
                                            </div>
                                        </div>
                                        <div className="w-100 bat-cls profile-flt-l fnt-12 fnt-wt-400">Battle No. {value.battle_no}</div>
                                        <div className="war-result-2 w-100 profile-flt-l">
                                            <img src={require("./../images/rm-you-lose.svg").default} alt="chat" className="img-fluid" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/*
                            <div className="row section paddingTop paddingBottom">
                                <div className="profile-war-info-inside w-100">
                                    <div className="profile-war-header w-100 profile-flt-l">
                                        <div className="w-100 profile-flt-l prof-war-head-left">{value.kd1_name} v/s {value.kd2_name}</div>
                                    </div>
            
                                    <div className="war-result w-100 profile-flt-l">
                                        <img src={require("./../images/rm-you-lose.svg").default} alt="chat" className="img-fluid" />
                                    </div>
                                    <div className="profile-war-footer w-100 profile-flt-l">
                                        <div className="w-50 profile-flt-l prof-war-head-left">
                                        &nbsp;
                                        </div>
                                        <Link to={{
                                            pathname:"/war-score",
                                            state: [value, value.war_id]
                                        }} className="w-50 profile-flt-l prof-war-head-right war-footer-right color-white">
                                            View War Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>;
                    row.push(card);
                } else if (value.war_status == 4) {
                    var card = <div className="row section mb-3" key={index}>
                        <div className='profile-war-info w-100 px-3' style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)) ,url(${img})`, backgroundSize: `100% 100%` }}>
                            <div className="row paddingTop">
                                <span className="profile-kd-name">{value.name}</span>
                            </div>
                            <div className="row paddingTop section">
                                <div className="region-war-ranks w-100">
                                    <Link to={{
                                        pathname: "/war-history",
                                        state: [value]
                                    }} className="reg-match-won w-50">
                                        <div>Matches Won <span className="hglt-class">{value.war_won}</span>
                                        </div>
                                    </Link>
                                    <Link to={{
                                        pathname: "/kingdom-leaderboard",
                                        state: [{ 'k_id': '' }]
                                    }} className="reg-regn-rang w-50">
                                        <div>Region Rank <span className="hglt-class">{value.rank}</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            {/*
                            <div className="row paddingTop">
                                <Link to={{
                                    pathname:"/war-history",
                                    state: [value]
                                }} className="profile-ww w-100">
                                    <div className="profile-ww-l profile-flt-l w-70">Wars Won</div>
                                    <div className="profile-ww-r profile-flt-l w-30">
                                        <span className="profile-ww-won">{value.war_won}/</span>
                                        <span className="profile-ww-total">{value.total_war}</span>
                                    </div>
                                </Link>
                            </div>
                            */}
                            <div className="row section paddingTop paddingBottom">
                                <Link
                                    to={{
                                        pathname: "/war-score",
                                        state: [value, value.war_id],
                                    }}
                                    className="profile-war-info-inside w-100"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="profile-war-info-inside w-100">
                                        <div className="w-100 battle-info profile-flt-l">
                                            <div className="w-75 profile-flt-l">
                                                <div className="w-100 profile-flt-l prof-war-head-left fnt-wt-500">{value.kd1_name} v/s {value.kd2_name}</div>
                                            </div>
                                            <div className="w-25 profile-flt-l">
                                                {/* <Link to={{
                                                pathname: "/war-score",
                                                state: [value, value.war_id]
                                            }} className="w-100 profile-flt-l prof-war-head-right color-white fnt-wt-400 fnt-10">
                                                Battle Details
                                            </Link> */}
                                            </div>
                                        </div>
                                        <div className="w-100 bat-cls profile-flt-l fnt-12 fnt-wt-400">Battle No. {value.battle_no}</div>
                                        <div className="war-result-2 w-100 profile-flt-l">
                                            <img src={require("./../images/rm-you-won.svg").default} alt="chat" className="img-fluid" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/*
                            <div className="row section paddingTop paddingBottom">
                                <div className="profile-war-info-inside w-100">
                                    <div className="profile-war-header w-100 profile-flt-l">
                                        <div className="w-100 profile-flt-l prof-war-head-left">{value.kd1_name} v/s {value.kd2_name}</div>
                                    </div>
                                    <div className="war-result w-100 profile-flt-l">
                                        <img src={require("./../images/rm-you-won.svg").default} alt="chat" className="img-fluid" />
                                    </div>
                                    <div className="profile-war-footer w-100 profile-flt-l">
                                        <div className="w-50 profile-flt-l prof-war-head-left">&nbsp;</div>
                                        <Link to={{
                                            pathname:"/war-score",
                                            state: [value, value.war_id]
                                        }} className="w-50 profile-flt-l prof-war-head-right war-footer-right color-white">
                                            View War Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>;
                    row.push(card);
                } else if (value.war_status == 0) {
                    var card = <div className="row section mb-3" key={index}>
                        <div className='profile-war-info w-100 px-3' style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)) ,url(${img})`, backgroundSize: `100% 100%` }}>
                            <div className="row paddingTop">
                                <span className="profile-kd-name">{value.name}</span>
                            </div>
                            <div className="row paddingTop section">
                                <div className="region-war-ranks w-100">
                                    <Link to={{
                                        pathname: "/war-history",
                                        state: [value]
                                    }} className="reg-match-won w-50">
                                        <div>Matches Won <span className="hglt-class">{value.war_won}</span>
                                        </div>
                                    </Link>
                                    <Link to={{
                                        pathname: "/kingdom-leaderboard",
                                        state: [{ 'k_id': '' }]
                                    }} className="reg-regn-rang w-50">
                                        <div>Region Rank <span className="hglt-class">{value.rank}</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            &nbsp;
                        </div>
                    </div>;
                    row.push(card);
                }
            }
            setKds(row);
        }
    }

    const getAllLiveWar = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ user_id: user_id }),

        };
        console.log(requestOptions);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-all-live-war', requestOptions);

        const data = await response.json();
        console.log(data);
        if (data.status === "success") {
            warRow.push(<div key="1111111" className='warUp'>
                Battle Updates
            </div>);
            for (const [index, value] of data.wars.entries()) {
                let kd1per = { width: (value.kd1_points * 100 / (value.kd1_points + value.kd2_points)).toFixed(0) + "%" };
                let kd2per = { width: (100 - (value.kd1_points * 100 / (value.kd1_points + value.kd2_points)).toFixed(0)) + "%" };
                if (value.kd1_points == 0 && value.kd2_points == 0) {
                    kd1per = { width: "50%" };
                    kd2per = { width: "50%" };
                }
                let status = '';
                if (value.status === 2) {
                    status = <img src={require("./../images/live.svg").default} alt="alt" />;
                } else if (value.status === 5) {
                    status = <img src={require("./../images/inReview.png").default} alt="alt" />;
                } else {
                    status = <img src={require("./../images/Ended.svg").default} alt="alt" />;
                }
                warRow.push(<div className="row mb-3 grey" key={"100000" + index}>
                    <div className="w-100 px-3 wp">
                        <div className="profile-war-header w-100 profile-flt-l">
                            <div className="w-70 profile-flt-l prof-war-head-left color-black">{value.kd1_name} v/s {value.kd2_name}</div>
                            <div>
                                <div className="w-30 profile-flt-l prof-war-head-right">{status}</div>
                            </div>
                            <div className="w-70 profile-flt-l prof-war-head-left color-black">Battle No. {value.battle_no}</div>
                        </div>
                        <div className="w-100 profile-flt-l">
                            <div className="score-range w-100">
                                <div className="score-range-left profile-flt-l color-black" style={kd1per}>&nbsp;</div>
                                <div className="score-range-right profile-flt-l color-black" style={kd2per}>&nbsp;</div>
                            </div>
                        </div>
                        <div className="profile-war-data-bottom w-100 profile-flt-l">
                            <div className="w-50 profile-flt-l text-alg-left">
                                <div className="w-100 profile-flt-l team-score color-black">{value.kd1_points.toLocaleString('en-In', { maximumFractionDigits: 0 })}</div>
                                <div className="w-100 profile-flt-l score-team color-black">{value.kd1_name}</div>
                            </div>
                            <div className="w-50 profile-flt-l text-alg-right">
                                <div className="w-100 profile-flt-l team-score color-black">{value.kd2_points.toLocaleString('en-In', { maximumFractionDigits: 0 })}</div>
                                <div className="w-100 profile-flt-l score-team color-black">{value.kd2_name}</div>
                            </div>
                        </div>
                    </div>
                </div>);
            }
            setWarUpdate(warRow);
        }
    };


    return (
        <>
            <Helmet link={
                [{ "rel": "stylesheet", "href": 'css/all-kingdoms.css' }]
            } />
            {error1 === true && (
                <Redirect to='/' />
            )}
            <div className="row no-gutters">
                <div className="application">
                    <div style={{
                        overflowY: 'scroll',
                        overflowX: `hidden`,
                        height: `100vh`,
                        width: `100%`
                    }} >
                        <div className="bg-gradient1">
                            <div className="appHeader bg-transparent text-light position-relative">
                                <div className="left h-100">
                                    {/* <a className="headerButton goBack" onClick={() => history.goBack()} >
                                <img src={require("./../images/faq-icon.png").default} alt="back"  className="img-fluid" />
                            </a> */}

                                    <img
                                        src={require("./../images/left-arrow-black.png").default}
                                        className="img-fluid backIcon"
                                        onClick={() => history.goBack()}
                                        style={{
                                            width: "22px",
                                            cursor: "pointer"
                                        }}
                                    />
                                </div>
                                <div className="right">
                                    <div className="headerButton">
                                        <Link to="/faq">
                                            <img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="search">

                        </div>
                        {/*
                <div className="leaderboard">
                    <Link to={{pathname:"/kingdom-leaderboard",
                        state:[{'k_id':''}]
                    }}  className="w-100 row leaderboard-p">
                        <div className="leaderboard-l">Kingdom Leaderboard</div>
                        <div className="leaderboard-r">
                            <img src={require("./../images/right.png").default} alt="details" className="img-fluid" />
                        </div>
                    </Link>
                </div>
                */}

                        <div className="section kingdom-availabel">
                            <div className="kingdom-war">
                                <div className="row mx-auto p-0">
                                    <span className="large-bold-2">My Regions</span>
                                </div>
                            </div>
                        </div>

                        {kds}
                        {/* <div className="leaderboard">
                    <Link to="/rm-leaderboard" className="w-100 row leaderboard-p">
                        <div className="leaderboard-l">Distributor Leaderboard</div>
                        <div className="leaderboard-r">
                            <img src={require("./../images/right.png").default} alt="details" className="img-fluid" />
                        </div>
                    </Link>
                </div> */}
                        <hr></hr>
                        {warUpdate}


                    </div>
                </div>

                <div className="bg_bor"></div>
            </div>
        </>
    );
}

export default AllKingdom;
